<template>
  <b-card
    no-body
    :class="[{'open': visible}, 'queue-specialists', margin]"
    @mouseenter="collapseOpen"
    @mouseleave="collapseClose"
  >
    <b-card-header
      :class="[{'collapsed': !visible}]"
      :aria-expanded="visible ? 'true' : 'false'"
      :aria-controls="collapseItemID"
      role="tab"
      data-toggle="collapse"
      @click="updateVisible(!visible)"
    >
      <span name="header">
        <b-row class="avatar-overlay">
          <b-avatar
            class="ml-1 mr-1"
            size="60"
            variant="light"
            :style="{color: getWidgetSettings.main_color}"
            :src="workspace.avatar"
            :text="setAcronym(workspace.description)"
          />
          <b-col align="start" :class="getWidgetSettings.show_rating ? 'column queue-specialist-name' : 'queue-specialist-name'">
            <span class="lead collapse-title queue-bloc-title">{{ shortenStringIfTooLong(workspace.name, 39, 13) }}</span><br>
            <small class="text-secondary">{{ shortenStringIfTooLong(workspace.description, 55, 12) }}</small><br>
            <b-form-rating
              v-if="getWidgetSettings.show_rating"
              :class="getWidgetSettings.show_rating ? 'my-form-control':''"
              :dir="getLanguage === 'ar' ? 'rtl' : 'ltr'"
              no-border
              inline
              :value="workspace.middle_star"
              readonly
              variant="warning"
              size="sm"
              show-value
              precision="1"
            />
          </b-col>
        </b-row>
      </span>
    </b-card-header>

    <b-collapse
      :id="collapseItemID"
      v-model="visible"
      :accordion="accordion"
      role="tabpanel"
    >
      <b-card-body class="collapse-pb" v-if="visible">
        <!-- if service don't have any service-->
        <div
          v-if="showServicesThisWorkspace(workspace).length === 0 && !getErrorServiceStatus"
          class="text-center queue-dont-have-specialist"
        >
          <small>
            {{ i18n.t('not-have-service') }}<br>
            {{ i18n.t('free-service-2') }}
            <b-link :style="{color: getWidgetSettings.main_color}">
              {{ getWidgetSettings.phone }}
            </b-link>
          </small>
        </div>
        <!-- error-->
        <div
          v-if="showServicesThisWorkspace(workspace).length === 0 && getErrorServiceStatus"
          class="text-center queue-dont-have-specialist"
        >
          <small class="text-danger">
            {{ i18n.t('error.something_wrong') }}
          </small>
        </div>
        <!-- specialists-->
        <service-with-timeslots
          v-for="(service, index) in showServicesThisWorkspace(workspace)"
          v-else
          :key="index"
          :service="service"
          :workspace="workspace"
          :main-color="getWidgetSettings.main_color"
          margin="queue-margin"
          @openForm="showForm"
        />
      </b-card-body>
    </b-collapse>
  </b-card>
</template>

<script>
import {
  BCard, BCardHeader, BCollapse, BCol, BRow, BAvatar, BCardBody, BFormRating, BLink,
} from 'bootstrap-vue'
import { v4 as uuidv4 } from 'uuid'
import Ripple from 'vue-ripple-directive'
import i18n from '@/libs/i18n'
import { mapGetters } from 'vuex'
import ServiceWithTimeslots from '@/components/booking/ServiceWithTimeslots.vue'
import { setAcronym, shortenStringIfTooLong } from '@/libs/utils'

export default {
  directives: {
    Ripple,
  },
  components: {
    ServiceWithTimeslots,
    BCard,
    BCardHeader,
    BCardBody,
    BCollapse,
    BCol,
    BRow,
    BAvatar,
    BFormRating,
    BLink,
  },
  props: {
    isVisible: {
      type: Boolean,
      default: false,
    },
    workspace: {
      type: Object,
      // eslint-disable-next-line vue/require-valid-default-prop
      default: {},
      required: true,
    },
    margin: {
      type: String,
      default: ''
    },
  },
  data() {
    return {
      visible: false,
      collapseItemID: '',
      openOnHover: this.$parent.hover,
      existTimeslot: true,
      setAcronym,
      shortenStringIfTooLong,
      i18n,
    }
  },
  computed: {
    ...mapGetters(['getErrorServiceStatus', 'getWidgetSettings', 'getServices', 'getLanguage']),
    accordion() {
      return this.$parent.accordion ? `accordion-${this.$parent.collapseID}` : null
    },
  },
  created() {
    this.collapseItemID = uuidv4()
    this.visible = this.isVisible
  },
  methods: {
    showForm(val) {
      this.$emit('openForm', { timeslot: val.timeslot, day: val.day, service: val.service, workspace: this.workspace })
    },
    async updateVisible(val = true) {
      this.visible = val
    },
    collapseOpen() {
      if (this.openOnHover) this.updateVisible(true)
    },
    collapseClose() {
      if (this.openOnHover) this.updateVisible(false)
    },
    showServicesThisWorkspace(workspace) {
      const answer = []
      // eslint-disable-next-line no-plusplus
      for (let i = 0; i < this.getServices.length; i++) {
        // eslint-disable-next-line camelcase
        const service = this.getServices[i]
        const serviceId = service.workspaces_by_service.find(item => item === workspace.id)
        if (serviceId !== undefined) {
          answer.push(service)
        }
      }
      return answer
    },
  },
}
</script>
<style>

</style>
